/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/require-default-props */
/* eslint-disable no-void  */
/* eslint-disable @typescript-eslint/no-unsafe-argument  */
import { useState, useRef, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Box,
  Typography,
  InputLabel,
  Card,
  CardMedia,
  CardContent,
  TextField,
  FormControlLabel,
  Switch,
  Button,
  FormHelperText,
  Slider,
  Link
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import useNotification from "../../../utils/notificationUtil";
import useConfirmDialog from '../../../components/ConfirmDialog'

import { TRAJECTORY_URLS, ACTION_TYPE } from '../../../constants/constants'
import { DataStoreContext, CONTEXT_ACTION_TYPE } from "../contexts/TrajectoryContext";

import { FormTrajectoryResult, FormTrajectoryResultLinkType } from '../types/trajectoryForm'
import {handleInputChange, handleInputChangeNameVal} from "../../../utils/formUtil"
import {excludeClassesWithChildren} from "../../workdb/utils/workUtil";
import pickImageUrl from "../../workdb/utils/pickImageUrl";
import useFetchAllQuery, {STATUSES, useFetchAllQueryHelper} from "../../../hooks/useFetchAllQuery";

import { ArmDocument } from '../../equipmentdb/types/pj1dbApiArm';
import { HandDocument } from '../../equipmentdb/types/pj1dbApiHand';
import { FingertipDocument } from '../../equipmentdb/types/pj1dbApiFingertip';
import {WorkClassDocument} from "../../../types/pj1dbApiWork";

import Pjdb1RadioGroup from '../../../components/inputs/Pjdb1RadioGroup';
import Pjdb1Button from '../../../components/inputs/Pjdb1Button';
import Pjdb1ToolTip from '../../../components/inputs/Pjdb1ToolTip';

import { findWork, findArm, findHand, findFingertip, FindWorkResponseData} from '../../../utils/awsAmplifyUtil'

import TrajectoryView from '../components/TrajectoryView';

import { ArmDetailDialog } from '../components/details/ArmDetailDialog';
import { HandDetailDialog } from '../components/details/HandDetailDialog';
import { FingertipDetailDialog } from '../components/details/FingertipDetailDialog';
import { WorkDetailDialog } from '../components/details/WorkDetailDialog';
import {FindModelResponse} from "../../../types/pj1dbApiHandling";
import useRepresentativeModel from "../../workdb/hooks/useRepresentativeModel";
import {DEFAULT_IMAGE_BLACK_URL, LOADING_IMAGE_URL, pickImageByClass} from "../../../utils/workUtil";

const IMAGE_WIDTH = 100;
const IMAGE_HEIGHT = 100;
const CARD_HEIGHT = IMAGE_HEIGHT;

let armListAll:ArmDocument[]=[];
let handListAll:HandDocument[]=[];
let fingertipListAll:FingertipDocument[]=[];
let workListAll:WorkClassDocument[]=[];
let workRepresentativeModels:FindModelResponse[]=[];

function useWorkClasses() {
  const queryResult = useFetchAllQuery<FindWorkResponseData<'class'>>({
    queryFn: (query) => findWork(
      'class',
      {
        version: "work-user",
        queryAttr: {},
      },
      query),
    needToFetchMore: (data, limit) => Object.entries(data?.items ?? {}).length === limit,
    enableAutoFetch: true,
  });
  return queryResult;
}

export default function TrajectoryResult() {
  const navigate = useNavigate();

  const { savedMsg, errorMsg } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const {ConfirmDialog, openConfirmDialog} = useConfirmDialog();
  const { state, dispatch } = useContext(DataStoreContext);
  const formRef = useRef<HTMLFormElement>(null);

  const [resultInputs, setResultInputs] = useState<FormTrajectoryResult>(state.trajectoryResultPage.info);
  const videoRef = useRef<HTMLVideoElement>(null);

  // contextに保存
  useEffect(()=>{
    dispatch({ type: CONTEXT_ACTION_TYPE.TRAJECTORY_RESULT,
      payload:{
        info: resultInputs
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[resultInputs]);

  // アーム選択関連
  const [armSearchKeyword, setArmSearchKeyword] = useState("");
  const [armCandidateList, setArmCandidateList] = useState<ArmDocument[]>([]);
  const [armSelectedList, setArmSelectedList] = useState<ArmDocument[]>([]);
  const [armDialogOpen, setArmDialogOpen] = useState(false);
  const [armDialogId, setArmDialogId] = useState("");

  // ハンド選択関連
  const [handSearchKeyword, setHandSearchKeyword] = useState("");
  const [handCandidateList, setHandCandidateList] = useState<HandDocument[]>([]);
  const [handSelectedList, setHandSelectedList] = useState<HandDocument[]>([]);
  const [handDialogOpen, setHandDialogOpen] = useState(false);
  const [handDialogId, setHandDialogId] = useState("");

  // 爪選択関連
  const [fingertipSearchKeyword, setFingertipSearchKeyword] = useState("");
  const [fingertipCandidateList, setFingertipCandidateList] = useState<FingertipDocument[]>([]);
  const [fingertipSelectedList, setFingertipSelectedList] = useState<FingertipDocument[]>([]);
  const [fingertipDialogOpen, setFingertipDialogOpen] = useState(false);
  const [fingertipDialogId, setFingertipDialogId] = useState("");

  // 対象物選択関連
  const [workSearchKeyword, setWorkSearchKeyword] = useState("");
  const [workCandidateList, setWorkCandidateList] = useState<WorkClassDocument[]>([]);
  const [workSelectedList, setWorkSelectedList] = useState<WorkClassDocument[]>([]);
  const [workDialogOpen, setWorkDialogOpen] = useState(false);
  const [workDialogId, setWorkDialogId] = useState("");

  const convertWorkClasses = (data: FindWorkResponseData<'class'>[]) =>
    excludeClassesWithChildren(
      data.map(workClasssResult => Object.values(workClasssResult.items)).flat()
    );

  //  const {status, data, fetchAll} = useWorkClasses();
  const {status, data } = useWorkClasses();
  useFetchAllQueryHelper({
    onChange: (newData, newStatus) => {
      const newWorkClasses = convertWorkClasses(newData);
      // console.log("newWorkClasses",newWorkClasses);
      if(newStatus===STATUSES.SUCCESS){
        newWorkClasses.sort((a,b) => a.attr.nameJp.localeCompare(b.attr.nameJp));
        workListAll = newWorkClasses;
        if(workListAll.length > 0){
          workListAll = excludeClassesWithChildren(workListAll).sort((a,b) => a.attr.nameJp.localeCompare(b.attr.nameJp));
          setWorkSelectedList(
            workListAll.filter((item)=> resultInputs.classIds.includes(item.attr['class-id']))
          );
        }
      }
    },
    data,
    status,
    initialStatus: STATUSES.IDLE,
  })
  const {models, isLoading: isWorkImageLoading} = useRepresentativeModel({
    workClasses: workListAll,
    acquiredRepresentativeModels: workRepresentativeModels,
  });
  const mergedModels = [...workRepresentativeModels, ...models];
  const uniqueModelIds =  Array.from(new Set(mergedModels.map(model => model.modelId)));
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  workRepresentativeModels = uniqueModelIds.map(modelId => mergedModels.find(model => model.modelId === modelId)!);

  // アーム検索（全件）
  const findArmProc = async () => {
    const cond = {};
    const result = await findArm(cond);
    if(!result.isSuccess) return;
    // console.log(result);
    if(result.data && Object.entries(result.data).length > 0){
      armListAll = Object.entries(result.data).map(([,armDoc])=>(armDoc));
      armListAll = armListAll.sort((a,b) => a.attr.armInfo.name.localeCompare(b.attr.armInfo.name));
      setArmSelectedList(
        armListAll.filter((item)=> resultInputs.armIds.includes(item.attr.armId))
      );
    }else{
      armListAll=[];
    }
  }
  // ハンド検索（全件）
  const findHandProc = async () => {
    const cond = {};
    const result = await findHand(cond);
    if(!result.isSuccess) return;
    // console.log(result);
    if(result.data && Object.entries(result.data).length > 0){
      handListAll = Object.entries(result.data).map(([,handDoc])=>(handDoc));
      handListAll = handListAll.sort((a,b) => a.attr.handInfo.name.localeCompare(b.attr.handInfo.name));
      setHandSelectedList(
        handListAll.filter((item)=> resultInputs.handIds.includes(item.attr.handId))
      );
    }else{
      handListAll=[];
    }
  }
  // 爪検索（全件）
  const findFingertProc = async () => {
    const cond = {};
    const result = await findFingertip(cond);
    if(!result.isSuccess) return;
    // console.log(result);
    if(result.data && Object.entries(result.data).length > 0){
      fingertipListAll = Object.entries(result.data).map(([,fingertipDoc])=>(fingertipDoc));
      fingertipListAll = fingertipListAll.sort((a,b) => a.attr.fingertipInfo.name.localeCompare(b.attr.fingertipInfo.name));
      setFingertipSelectedList(
        fingertipListAll.filter((item)=> resultInputs.fingertipIds.includes(item.attr.fingertipId))
      );
    }else{
      fingertipListAll=[];
    }
  }

  const SELMODE = {
    ARM: "arm",
    HAND: "hand",
    FINGERTIP: "fingertip",
    WORK: "work",
  };
  // キーワード変更
  const changeAutoComp = (mode:string, event: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>|null) => {
    let sKey = "";
    if(event!==null) sKey = event.target.value;

    if(mode===SELMODE.ARM){
      if(event!==null){
        setArmSearchKeyword(sKey);
      }else{
        sKey = armSearchKeyword;
      }
      let tempCandidateList:ArmDocument[] = []
      if(sKey!==""){
        tempCandidateList =
          armListAll.filter((item)=>
            item.attr.armInfo.name.toUpperCase().includes(String(sKey).toUpperCase()) ||
            item.attr.armInfo.manufacturer.toUpperCase().includes(String(sKey).toUpperCase()) ||
            (
              item.attr.armInfo.number &&
              item.attr.armInfo.number.toUpperCase().includes(String(sKey).toUpperCase())
            ) ||
            (
              item.attr.productInfo.keyword &&
              item.attr.productInfo.keyword.filter((kwd)=>(kwd.toUpperCase().includes(String(sKey).toUpperCase()))).length > 0
            ) ||
            (
              item.attr.productInfo.description &&
              item.attr.productInfo.description.toUpperCase().includes(String(sKey).toUpperCase())
            )
          );
      }else{
        tempCandidateList = [];
      }
      setArmCandidateList(tempCandidateList);

    }else if(mode===SELMODE.HAND){
      if(event!==null){
        setHandSearchKeyword(sKey);
      }else{
        sKey = handSearchKeyword;
      }
      let tempCandidateList:HandDocument[] = []
      if(sKey!==""){
        tempCandidateList =
          handListAll.filter((item)=>
            item.attr.handInfo.name.toUpperCase().includes(String(sKey).toUpperCase()) ||
            item.attr.handInfo.producer.toUpperCase().includes(String(sKey).toUpperCase()) ||
            (
              item.attr.handInfo.number &&
              item.attr.handInfo.number.toUpperCase().includes(String(sKey).toUpperCase())
            ) ||
            (
              item.attr.productInfo.keyword &&
              item.attr.productInfo.keyword.filter((kwd)=>(kwd.toUpperCase().includes(String(sKey).toUpperCase()))).length > 0
            ) ||
            (
              item.attr.productInfo.description &&
              item.attr.productInfo.description.toUpperCase().includes(String(sKey).toUpperCase())
            )
          );
      }else{
        tempCandidateList = [];
      }
      setHandCandidateList(tempCandidateList);

    }else if(mode===SELMODE.FINGERTIP){
      if(event!==null){
        setFingertipSearchKeyword(sKey);
      }else{
        sKey = fingertipSearchKeyword;
      }
      let tempCandidateList:FingertipDocument[] = []
      if(sKey!==""){
        tempCandidateList =
          fingertipListAll.filter((item)=>
            item.attr.fingertipInfo.name.toUpperCase().includes(String(sKey).toUpperCase()) ||
            item.attr.fingertipInfo.producer.toUpperCase().includes(String(sKey).toUpperCase()) ||
            (
              item.attr.fingertipInfo.number &&
              item.attr.fingertipInfo.number.toUpperCase().includes(String(sKey).toUpperCase())
            ) ||
            (
              item.attr.productInfo.keyword &&
              item.attr.productInfo.keyword.filter((kwd)=>(kwd.toUpperCase().includes(String(sKey).toUpperCase()))).length > 0
            ) ||
            (
              item.attr.productInfo.description &&
              item.attr.productInfo.description.toUpperCase().includes(String(sKey).toUpperCase())
            )
          );
      }else{
        tempCandidateList = [];
      }
      setFingertipCandidateList(tempCandidateList);

    }else if(mode===SELMODE.WORK){
      if(event!==null){
        setWorkSearchKeyword(sKey);
      }else{
        sKey = workSearchKeyword;
      }
      let tempCandidateList:WorkClassDocument[] = []
      if(sKey!==""){
        tempCandidateList =
          workListAll.filter((item)=>
            item.attr.nameJp.toUpperCase().includes(String(sKey).toUpperCase()) ||
            (
              item.attr.nameEn &&
              item.attr.nameEn.toUpperCase().includes(String(sKey).toUpperCase())
            ) ||
            (
              item.attr.code &&
              item.attr.code.toUpperCase().includes(String(sKey).toUpperCase())
            )
          );
      }else{
        tempCandidateList = [];
      }
      setWorkCandidateList(tempCandidateList);
    }
  }
  // 選択スイッチ変更
  const changeSwitch = (mode:string, id:string, checked: boolean)=>{
    // console.log(mode, id, checked);
    if(mode===SELMODE.ARM){
      let tempArmIds:string[] = resultInputs.armIds;
      if(checked){
        if(!resultInputs.armIds.includes(id)){
          tempArmIds.push(id);
        }
      }else{
        tempArmIds = tempArmIds.filter((armId)=>(armId!==id));
      }
      handleInputChangeNameVal<FormTrajectoryResult>("armIds", tempArmIds, resultInputs, setResultInputs)
      setArmSelectedList(
        armListAll.filter((item)=> tempArmIds.includes(item.attr.armId))
      );
    }else if(mode===SELMODE.HAND){
      let tempHandIds:string[] = resultInputs.handIds;
      if(checked){
        if(!resultInputs.handIds.includes(id)){
          tempHandIds.push(id);
        }
      }else{
        tempHandIds = tempHandIds.filter((handId)=>(handId!==id));
      }
      handleInputChangeNameVal<FormTrajectoryResult>("handIds", tempHandIds, resultInputs, setResultInputs)
      setHandSelectedList(
        handListAll.filter((item)=> tempHandIds.includes(item.attr.handId))
      );
    }else if(mode===SELMODE.FINGERTIP){
      let tempFingertipIds:string[] = resultInputs.fingertipIds;
      if(checked){
        if(!resultInputs.fingertipIds.includes(id)){
          tempFingertipIds.push(id);
        }
      }else{
        tempFingertipIds = tempFingertipIds.filter((fingertipId)=>(fingertipId!==id));
      }
      handleInputChangeNameVal<FormTrajectoryResult>("fingertipIds", tempFingertipIds, resultInputs, setResultInputs)
      setFingertipSelectedList(
        fingertipListAll.filter((item)=> tempFingertipIds.includes(item.attr.fingertipId))
      );
    }else if(mode===SELMODE.WORK){
      let tempClassIds:string[] = resultInputs.classIds;
      if(checked){
        if(!resultInputs.classIds.includes(id)){
          tempClassIds.push(id);
        }
      }else{
        tempClassIds = tempClassIds.filter((classId)=>(classId!==id));
      }
      handleInputChangeNameVal<FormTrajectoryResult>("classIds", tempClassIds, resultInputs, setResultInputs)
      setWorkSelectedList(
        workListAll.filter((item)=> tempClassIds.includes(item.attr['class-id']))
      );
    }
  }

  // 秒数を00:00.000形式に変換
  const formatTime = (time: number): string => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    const milliseconds = Math.floor((time % 1) * 1000); // 小数点以下をミリ秒に変換
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}.${String(milliseconds).padStart(3, "0")}`;
  };

  // 軌道データ解析
  const TrajectoryParser = (infoRes:FormTrajectoryResult):FormTrajectoryResult => {
    const resInfo:FormTrajectoryResult = infoRes;

    // ステップ数
    const steps = resInfo.trajectory.split("\n");
    const stepNum = steps.length -1;
    resInfo.trajectoryStepNum = stepNum;

    // リンク数取得
    const linkNum = Math.trunc(steps[0].split(",").length / 3);
    resInfo.trajectoryObj = [];
    resInfo.dispLinks = [];
    for (let i = 0; i < linkNum; i += 1) {
      resInfo.dispLinks.push({
        id: i+1,
        name: `j${i+1}`,
        disp:true
      });
      resInfo.trajectoryObj.push([]);
    }

    // csvをリンクごとの配列に
    steps.forEach(step=>{
      const values = step.split(",").map((val) => parseFloat(val.trim()));
      for (let i = 0; i < linkNum; i += 1) {
        // three.js (x:右方向、y:上方向、z:奥行)なので、csv項目を入れ替える
        // x:csv2項目目、y:csv3項目目、z:csv1項目目
        resInfo.trajectoryObj[i].push([values[i*3+1], values[i*3+2], values[i*3]]);
      }
    });

    resInfo.dispPos = null;
    resInfo.sliderMin = 0;
    resInfo.sliderMax = stepNum;
    resInfo.curPos = {timeStr:formatTime(0),step:0};

    return resInfo;
  }

  // videoの読込完了
  const handleLoadedMetadata = () => {
    if (videoRef.current) {
      console.log("videoRef.current.duration",videoRef.current.duration);
      setResultInputs({...resultInputs,
        videoSecond: videoRef.current.duration
      });
    }
  };

  // 表示リンク修正
  const changeDispLink = (dispLink:FormTrajectoryResultLinkType, chk:boolean) =>{
    // console.log("dispLink", dispLink);
    setResultInputs({...resultInputs,
      dispLinks: resultInputs.dispLinks.map(row => row.id!==dispLink.id ? row : { ...row, disp:chk })
    });
  }


  // 再生位置修正
  const positionChange = (event: Event|null, newValue: number | number[]) =>{
    const curPos = newValue as number;
    let curSec = 0;
    if(videoRef.current){
      curSec = resultInputs.videoSecond / resultInputs.trajectoryStepNum * curPos;
      videoRef.current.currentTime = curSec;
      videoRef.current.pause();
    }

    setResultInputs({...resultInputs,
      dispPos: curPos,
      curPos: {timeStr:formatTime(curSec),step:curPos}
    });
  }

  // 目標位置選択
  const selectGoal = () =>{
    setResultInputs({...resultInputs, goal: resultInputs.curPos});
  }
  const clearGoal = () =>{
    setResultInputs({...resultInputs, goal:null});
  }
  // 選択済み位置に移動
  const selectedGoalTime = () =>{
    if(resultInputs.goal){
      positionChange(null,resultInputs.goal.step);
    }
  }

  useEffect(()=>{
    let stateForm = state.trajectoryResultPage.info;

    if(!stateForm.trajectory){
      dispatch({ type: CONTEXT_ACTION_TYPE.TAB , payload: TRAJECTORY_URLS.TRAJECTORY_REGISTE.TAB_IDX });
      navigate(TRAJECTORY_URLS.TRAJECTORY_REGISTE.URL);
    }

    stateForm = TrajectoryParser(stateForm);
    setResultInputs(stateForm);

    // 初回のハンド・アーム・爪情報検索
    void findArmProc();
    void findHandProc();
    void findFingertProc();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])


  // 登録・更新処理
  const editData = async () => {
    try {
      let inputErr = false;
      // input項目のバリデーション
      if (!formRef.current?.reportValidity()) {
        inputErr = true;
      }

      if(inputErr){
        errorMsg("入力内容に誤りがあります。");
        return;
      }

      // 確認ダイアログ
      const result = await openConfirmDialog();
      if (result !== "confirm") {
        return;
      }

      // ローディングボタン
      setIsLoading(true);

      // コンソールログに出力
      console.log(
        "TrajectoryRegiste log ---------------------------",
        "\n trajectory : ",
        resultInputs.trajectory,
        "\n video : ",
        resultInputs.video,
        "\n goal : ",
        resultInputs.goal,
        "\n action : ",
        resultInputs.action,
        "\n armIds : ",
        resultInputs.armIds,
        "\n handIds : ",
        resultInputs.handIds,
        "\n fingertipIds : ",
        resultInputs.fingertipIds,
        "\n classIds : ",
        resultInputs.classIds,
      );

      savedMsg();

    } catch (error) {
      console.log("registData Error : ", error);
      errorMsg("軌道生成処理が失敗しました。");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <Grid container spacing={0.5} alignItems="flexStart" sx={{px:2,mt:2}}>
        <Grid>
          <Typography variant="body1" color='error'>※入力すべき値は</Typography>
        </Grid>
        <Grid><HelpOutlineIcon color='secondary'/></Grid>
        <Grid>
          <Typography variant="body1" color='error'>(tips)を参照して定めること。</Typography>
        </Grid>
      </Grid>
      <Container maxWidth="lg" sx={{mt:2}}>
        <Card sx={{p:3}}>
          <Grid container spacing={3} alignItems="center" sx={{mb:1}} >
            <Grid width="130px">
              <Typography variant="h6">軌道生成結果</Typography>
            </Grid>
            <Grid sx={{flexGrow: 1}}>
              <Pjdb1ToolTip toolTip="軌道の始点から終点に向かって色が薄くなっている" sx={{mt:1}} />
            </Grid>
          </Grid>

          <form ref={formRef}>
            <Grid container spacing={2} alignItems="flexStart">
              <Grid size={{xs: 12, md: 6}} sx={{pt: "0px !important", border: "1px solid rgba(0, 0, 0, 0.23)", position: "relative", aspectRatio:"4 / 3"}}>
                <TrajectoryView
                  trajectoryObj={resultInputs.trajectoryObj}
                  dispLinks={resultInputs.dispLinks}
                  dispPos={resultInputs.dispPos}
                />
              </Grid>
              <Grid size={{xs: 12, md: 6}} sx={{pt: "0px !important", aspectRatio:"4 / 3", display: "flex", justifyContent: "center"}}>
                <video controls style={{width:"100%",backgroundColor:"rgba(0, 0, 0, 0.23)"}}
                ref={videoRef} onLoadedMetadata={handleLoadedMetadata}>
                  <source src={resultInputs.video} type="video/mp4" />
                </video>
              </Grid>
              <Grid size={{xs: 12 }} sx={{pt: "0px !important"}}>
                <Grid container spacing={2} alignItems="start" sx={{mt:1}}>
                  <Grid width="90px">
                    <InputLabel variant='standard' sx={{mt:1,color: 'text.primary'}}>表示リンク</InputLabel>
                  </Grid>
                  <Grid>
                    {resultInputs.dispLinks.map(row =>(
                      <FormControlLabel
                        key={row.id}
                        control={
                          <Switch
                            name={row.name}
                            checked={row.disp}
                            onChange={(e,chk)=>{changeDispLink(row, chk)}}
                          />
                        }
                        label={row.name}
                        onClick={(e)=>{ e.stopPropagation(); }}
                      />
                    ))}
                  </Grid>
                  <Grid>
                    <Pjdb1ToolTip toolTip={<span>軌道描画するリンクのOnOffを選択可能<br />各リンクのうちアームの根元に近い方から順に番号付けされている</span>} sx={{mt:1}} />
                  </Grid>
                </Grid>

                <Grid container spacing={2} alignItems="start" sx={{mt:1}}>
                  <Grid width="90px">
                    <InputLabel variant='standard' sx={{mt:1,color: 'text.primary'}}>再生位置</InputLabel>
                  </Grid>
                  <Grid sx={{width:{xs: "calc(100% - 150px)", md: "calc(50% - 100px)"}}}>
                    <Slider defaultValue={0} aria-label="Position" sx={{mt:0.5}}
                      value={resultInputs.dispPos===null ? 0 :resultInputs.dispPos}
                      onChange={positionChange}
                      min={resultInputs.sliderMin}
                      max={resultInputs.sliderMax}
                      step={1}
                    />
                    <FormHelperText sx={{mt:0}}>{resultInputs.curPos.timeStr}</FormHelperText>
                  </Grid>
                  <Grid>
                    <Pjdb1ToolTip toolTip={<span>左記バーを動かして再生位置を移動<br />軌道生成結果と動画再生位置は同期されている</span>} sx={{mt:1}} />
                  </Grid>
                </Grid>

                <Grid container spacing={2} alignItems="start" sx={{mt:1}}>
                  <Grid width="90px">
                    <InputLabel variant='standard' sx={{mt:1,color: 'text.primary'}}>目標位置</InputLabel>
                  </Grid>
                  <Grid>
                    <Grid container spacing={1} alignItems="start" sx={{mt:1}}>
                      <Grid>
                        <Button variant="contained" color="primary" size="small" sx={{mt: 0}} onClick={selectGoal}>目標位置選択</Button>
                      </Grid>
                      <Grid>
                        <Pjdb1ToolTip toolTip={<span>再生位置バーにて物体を置いたタイミングに移動、<br />左記[目標位置選択]にて目標位置として確定させる</span>} sx={{mt:0.5}} />
                      </Grid>
                    </Grid>
                    {resultInputs.goal &&
                      <Grid container spacing={2} alignItems="center" sx={{mt:1}}>
                        <Grid>
                          <InputLabel variant='standard' sx={{color: 'text.primary'}}>選択した位置</InputLabel>
                        </Grid>
                        <Grid>
                          <Link href="#" color="info" onClick={(e)=>{
                            e.preventDefault();
                            selectedGoalTime();
                          }}>
                            {resultInputs.goal.timeStr}
                          </Link>
                        </Grid>
                        <Grid>
                          <Button variant="contained" color="inherit" size="small" sx={{mt: 0}} onClick={clearGoal}>クリア</Button>
                        </Grid>
                      </Grid>
                    }
                  </Grid>
                </Grid>

                <Grid container spacing={2} alignItems="start" sx={{mt:1}}>
                  <Grid width="90px">
                    <InputLabel variant='standard' sx={{mt:2,color: 'text.primary'}}>アクション</InputLabel>
                  </Grid>
                  <Grid>
                    <Pjdb1RadioGroup
                      name="action" value={resultInputs.action}
                      onChange={(e)=>(handleInputChange<FormTrajectoryResult>(e, resultInputs, setResultInputs))}
                      radios={ACTION_TYPE.map((row)=>({btnKey:row.key,btnLbl:row.label}))}
                      required
                      toolTip="アクション分類を選択"
                    />
                  </Grid>
                </Grid>

              </Grid>
            </Grid>

            <Typography variant="subtitle1" sx={{fontWeight:"bold",mt:3.5}}>生成された軌道を参照する想定の機器や把持対象物を以下で選択してください。</Typography>

            <Box sx={{mt:1,ml:2,borderTop:"1px solid rgba(0, 0, 0, 0.23)"}}>
              <InputLabel variant='standard' sx={{mt:2,color: 'text.primary'}}>アーム選択</InputLabel>
              <Grid container spacing={2} alignItems="start" sx={{px:3,py:0,mt:1,alignItems:"stretch"}}>
                <Grid size={{xs:6}} sx={{pt:2}}>
                  <Grid container spacing={2} alignItems="start" sx={{p:0,m:0}}>
                    <Grid sx={{p:"0 !important"}}>
                      <InputLabel variant='standard' sx={{pt:0,color: 'text.primary'}}>アーム検索</InputLabel>
                    </Grid>
                    <Grid sx={{pt:"0 !important"}}>
                      <Pjdb1ToolTip toolTip={
                        <span>
                          下記に製品名を入力して候補を検索<br />
                          製品カードをクリックでアーム詳細ページに遷移<br />
                          製品カードの選択をONにして選択済みアームに移動
                        </span>
                      } sx={{p:0}} />
                    </Grid>
                  </Grid>
                  <Box sx={{ width: 0.8 }}>
                    <TextField
                      label="製品名、製造者、型番、特徴などを入力"
                      name="armSearchKeyword" value={armSearchKeyword}
                      variant="outlined" size="small"
                      margin="dense" fullWidth
                      onChange={(e)=>(changeAutoComp(SELMODE.ARM, e))}
                    />
                  </Box>
                  <Box sx={{ mt:0, pr:4 }}>
                    {armCandidateList.map(row =>(
                      <Card key={row.attr.armId} sx={{ display: 'flex', height:CARD_HEIGHT, mt:2, cursor:"pointer"}}
                        onClick={()=>{ setArmDialogId(row.attr.armId); setArmDialogOpen(true); }} >
                        <CardMedia
                          component="img"
                          sx={{ width: IMAGE_WIDTH, height: IMAGE_HEIGHT , objectFit:'contain'}}
                          image={row.url?.image[0]}
                          alt={row.attr.armInfo.name}
                        />
                        <CardContent sx={{p:1}}>
                          <Typography variant="subtitle2" noWrap component='p' sx={{mt:0.5}}>
                            製品名：{row.attr.armInfo.name}
                          </Typography>
                          <Typography variant="subtitle2" noWrap component='p' sx={{mt:0.5,color:"#888"}}>
                            製造者：{row.attr.armInfo.manufacturer}
                          </Typography>
                          <FormControlLabel
                            control={
                              <Switch
                                name={row.attr.armId}
                                checked={resultInputs.armIds.includes(row.attr.armId)}
                                onChange={(e,chk)=>{changeSwitch(SELMODE.ARM, row.attr.armId, chk)}}
                              />
                            }
                            label="選択"
                            onClick={(e)=>{ e.stopPropagation(); }}
                          />
                        </CardContent>
                      </Card>
                    ))}
                  </Box>
                </Grid>
                <Grid size={{xs:6}} sx={{borderLeft:"1px solid rgba(0, 0, 0, 0.23)",pt:2,pl:2}}>
                  <InputLabel variant='standard' sx={{pt:0,color: 'text.primary'}}>選択済みアーム</InputLabel>
                  <Box sx={{ mt:"74px", pr:2 }}>
                    {armSelectedList.map(row =>(
                      <Card sx={{ mt:2 }} key={row.attr.armId} >
                        <Grid container spacing={0} alignItems="start" sx={{p:0,m:0,color:"text.primary", flexWrap:"nowrap", cursor:"pointer"}}
                          onClick={()=>{ setArmDialogId(row.attr.armId); setArmDialogOpen(true); }} >
                          <Grid sx={{flexShrink:0}}>
                            <CardMedia
                              component="img"
                              sx={{ width: IMAGE_WIDTH, height: IMAGE_HEIGHT , objectFit:'contain'}}
                              image={row.url?.image[0]}
                              alt={row.attr.armInfo.name}
                            />
                          </Grid>
                          <Grid>
                            <CardContent sx={{p:1,pb:"0 !important"}}>
                              <Typography variant="subtitle2" noWrap component='p' sx={{mt:0.5}}>
                                製品名：{row.attr.armInfo.name}
                              </Typography>
                              <Typography variant="subtitle2" noWrap component='p' sx={{mt:0.5,color:"#888"}}>
                                製造者：{row.attr.armInfo.manufacturer}
                              </Typography>
                              <FormControlLabel
                                control={
                                  <Switch
                                    name={row.attr.armId}
                                    checked
                                    onChange={()=>{changeSwitch(SELMODE.ARM, row.attr.armId, false)}}
                                  />
                                }
                                label="選択"
                                onClick={(e)=>{ e.stopPropagation(); }}
                              />
                            </CardContent>
                          </Grid>
                        </Grid>
                      </Card>
                    ))}
                  </Box>

                </Grid>
              </Grid>
            </Box>

            <Box sx={{mt:3.5,ml:2,borderTop:"1px solid rgba(0, 0, 0, 0.23)"}}>
              <InputLabel variant='standard' sx={{mt:2,color: 'text.primary'}}>ハンド選択</InputLabel>
              <Grid container spacing={2} alignItems="start" sx={{px:3,py:0,mt:1,alignItems:"stretch"}}>
                <Grid size={{xs:6}} sx={{pt:2}}>
                  <Grid container spacing={2} alignItems="start" sx={{p:0,m:0}}>
                    <Grid sx={{p:"0 !important"}}>
                      <InputLabel variant='standard' sx={{pt:0,color: 'text.primary'}}>ハンド検索</InputLabel>
                    </Grid>
                    <Grid sx={{pt:"0 !important"}}>
                      <Pjdb1ToolTip toolTip={
                        <span>
                          下記に製品名を入力して候補を検索<br />
                          製品カードをクリックでハンド詳細ページに遷移<br />
                          製品カードの選択をONにして選択済みハンドに移動
                        </span>
                      } sx={{p:0}} />
                    </Grid>
                  </Grid>
                  <Box sx={{ width: 0.8 }}>
                    <TextField
                      label="製品名、製造者、型番、特徴などを入力"
                      name="handSearchKeyword" value={handSearchKeyword}
                      variant="outlined" size="small"
                      margin="dense" fullWidth
                      onChange={(e)=>(changeAutoComp(SELMODE.HAND, e))}
                    />
                  </Box>
                  <Box sx={{ mt:0, pr:4 }}>
                    {handCandidateList.map(row =>(
                      <Card key={row.attr.handId} sx={{ display: 'flex', height:CARD_HEIGHT, mt:2, cursor:"pointer"}}
                        onClick={()=>{ setHandDialogId(row.attr.handId); setHandDialogOpen(true); }} >
                        <CardMedia
                          component="img"
                          sx={{ width: IMAGE_WIDTH, height: IMAGE_HEIGHT , objectFit:'contain'}}
                          image={row.url?.image[0]}
                          alt={row.attr.handInfo.name}
                        />
                        <CardContent sx={{p:1}}>
                          <Typography variant="subtitle2" noWrap component='p' sx={{mt:0.5}}>
                            製品名：{row.attr.handInfo.name}
                          </Typography>
                          <Typography variant="subtitle2" noWrap component='p' sx={{mt:0.5,color:"#888"}}>
                            製造者：{row.attr.handInfo.producer}
                          </Typography>
                          <FormControlLabel
                            control={
                              <Switch
                                name={row.attr.handId}
                                checked={resultInputs.handIds.includes(row.attr.handId)}
                                onChange={(e,chk)=>{changeSwitch(SELMODE.HAND, row.attr.handId, chk)}}
                              />
                            }
                            label="選択"
                            onClick={(e)=>{ e.stopPropagation(); }}
                          />
                        </CardContent>
                      </Card>
                    ))}
                  </Box>
                </Grid>
                <Grid size={{xs:6}} sx={{borderLeft:"1px solid rgba(0, 0, 0, 0.23)",pt:2,pl:2}}>
                  <InputLabel variant='standard' sx={{pt:0,color: 'text.primary'}}>選択済みハンド</InputLabel>
                  <Box sx={{ mt:"74px", pr:2 }}>
                    {handSelectedList.map(row =>(
                      <Card sx={{ mt:2 }} key={row.attr.handId} >
                        <Grid container spacing={0} alignItems="start" sx={{p:0,m:0,color:"text.primary", flexWrap:"nowrap", cursor:"pointer"}}
                          onClick={()=>{ setHandDialogId(row.attr.handId); setHandDialogOpen(true); }} >
                          <Grid sx={{flexShrink:0}}>
                            <CardMedia
                              component="img"
                              sx={{ width: IMAGE_WIDTH, height: IMAGE_HEIGHT , objectFit:'contain'}}
                              image={row.url?.image[0]}
                              alt={row.attr.handInfo.name}
                            />
                          </Grid>
                          <Grid>
                            <CardContent sx={{p:1,pb:"0 !important"}}>
                              <Typography variant="subtitle2" noWrap component='p' sx={{mt:0.5}}>
                                製品名：{row.attr.handInfo.name}
                              </Typography>
                              <Typography variant="subtitle2" noWrap component='p' sx={{mt:0.5,color:"#888"}}>
                                製造者：{row.attr.handInfo.producer}
                              </Typography>
                              <FormControlLabel
                                control={
                                  <Switch
                                    name={row.attr.handId}
                                    checked
                                    onChange={()=>{changeSwitch(SELMODE.HAND, row.attr.handId, false)}}
                                  />
                                }
                                label="選択"
                                onClick={(e)=>{ e.stopPropagation(); }}
                              />
                            </CardContent>
                          </Grid>
                        </Grid>
                      </Card>
                    ))}
                  </Box>

                </Grid>
              </Grid>
            </Box>

            <Box sx={{mt:3.5,ml:2,borderTop:"1px solid rgba(0, 0, 0, 0.23)"}}>
              <InputLabel variant='standard' sx={{mt:2,color: 'text.primary'}}>爪選択</InputLabel>
              <Grid container spacing={2} alignItems="start" sx={{px:3,py:0,mt:1,alignItems:"stretch"}}>
                <Grid size={{xs:6}} sx={{pt:2}}>
                  <Grid container spacing={2} alignItems="start" sx={{p:0,m:0}}>
                    <Grid sx={{p:"0 !important"}}>
                      <InputLabel variant='standard' sx={{pt:0,color: 'text.primary'}}>爪検索</InputLabel>
                    </Grid>
                    <Grid sx={{pt:"0 !important"}}>
                      <Pjdb1ToolTip toolTip={
                        <span>
                          下記に製品名を入力して候補を検索<br />
                          製品カードをクリックで爪詳細ページに遷移<br />
                          製品カードの選択をONにして選択済み爪に移動
                        </span>
                      } sx={{p:0}} />
                    </Grid>
                  </Grid>
                  <Box sx={{ width: 0.8 }}>
                    <TextField
                      label="製品名、製造者、型番、特徴などを入力"
                      name="fingertipSearchKeyword" value={fingertipSearchKeyword}
                      variant="outlined" size="small"
                      margin="dense" fullWidth
                      onChange={(e)=>(changeAutoComp(SELMODE.FINGERTIP, e))}
                    />
                  </Box>
                  <Box sx={{ mt:0, pr:4 }}>
                    {fingertipCandidateList.map(row =>(
                      <Card key={row.attr.fingertipId} sx={{ display: 'flex', height:CARD_HEIGHT, mt:2, cursor:"pointer"}}
                        onClick={()=>{ setFingertipDialogId(row.attr.fingertipId); setFingertipDialogOpen(true); }} >
                        <CardMedia
                          component="img"
                          sx={{ width: IMAGE_WIDTH, height: IMAGE_HEIGHT , objectFit:'contain'}}
                          image={row.url?.image[0]}
                          alt={row.attr.fingertipInfo.name}
                        />
                        <CardContent sx={{p:1}}>
                          <Typography variant="subtitle2" noWrap component='p' sx={{mt:0.5}}>
                            製品名：{row.attr.fingertipInfo.name}
                          </Typography>
                          <Typography variant="subtitle2" noWrap component='p' sx={{mt:0.5,color:"#888"}}>
                            製造者：{row.attr.fingertipInfo.producer}
                          </Typography>
                          <FormControlLabel
                            control={
                              <Switch
                                name={row.attr.fingertipId}
                                checked={resultInputs.fingertipIds.includes(row.attr.fingertipId)}
                                onChange={(e,chk)=>{changeSwitch(SELMODE.FINGERTIP, row.attr.fingertipId, chk)}}
                              />
                            }
                            label="選択"
                            onClick={(e)=>{ e.stopPropagation(); }}
                          />
                        </CardContent>
                      </Card>
                    ))}
                  </Box>
                </Grid>
                <Grid size={{xs:6}} sx={{borderLeft:"1px solid rgba(0, 0, 0, 0.23)",pt:2,pl:2}}>
                  <InputLabel variant='standard' sx={{pt:0,color: 'text.primary'}}>選択済み爪</InputLabel>
                  <Box sx={{ mt:"74px", pr:2 }}>
                    {fingertipSelectedList.map(row =>(
                      <Card sx={{ mt:2 }} key={row.attr.fingertipId} >
                        <Grid container spacing={0} alignItems="start" sx={{p:0,m:0,color:"text.primary", flexWrap:"nowrap", cursor:"pointer"}}
                          onClick={()=>{ setFingertipDialogId(row.attr.fingertipId); setFingertipDialogOpen(true); }} >
                          <Grid sx={{flexShrink:0}}>
                            <CardMedia
                              component="img"
                              sx={{ width: IMAGE_WIDTH, height: IMAGE_HEIGHT , objectFit:'contain'}}
                              image={row.url?.image[0]}
                              alt={row.attr.fingertipInfo.name}
                            />
                          </Grid>
                          <Grid>
                            <CardContent sx={{p:1,pb:"0 !important"}}>
                              <Typography variant="subtitle2" noWrap component='p' sx={{mt:0.5}}>
                                製品名：{row.attr.fingertipInfo.name}
                              </Typography>
                              <Typography variant="subtitle2" noWrap component='p' sx={{mt:0.5,color:"#888"}}>
                                製造者：{row.attr.fingertipInfo.producer}
                              </Typography>
                              <FormControlLabel
                                control={
                                  <Switch
                                    name={row.attr.fingertipId}
                                    checked
                                    onChange={()=>{changeSwitch(SELMODE.FINGERTIP, row.attr.fingertipId, false)}}
                                  />
                                }
                                label="選択"
                                onClick={(e)=>{ e.stopPropagation(); }}
                              />
                            </CardContent>
                          </Grid>
                        </Grid>
                      </Card>
                    ))}
                  </Box>

                </Grid>
              </Grid>
            </Box>

            <Box sx={{mt:3.5,ml:2,borderTop:"1px solid rgba(0, 0, 0, 0.23)"}}>
              <InputLabel variant='standard' sx={{mt:2,color: 'text.primary'}}>対象物選択</InputLabel>
              <Grid container spacing={2} alignItems="start" sx={{px:3,py:0,mt:1,alignItems:"stretch"}}>
                <Grid size={{xs:6}} sx={{pt:2}}>
                  <Grid container spacing={2} alignItems="start" sx={{p:0,m:0}}>
                    <Grid sx={{p:"0 !important"}}>
                      <InputLabel variant='standard' sx={{pt:0,color: 'text.primary'}}>対象物検索</InputLabel>
                    </Grid>
                    <Grid sx={{pt:"0 !important"}}>
                      <Pjdb1ToolTip toolTip={
                        <span>
                          下記に製品名を入力して候補を検索<br />
                          製品カードをクリックで対象物詳細ページに遷移<br />
                          製品カードの選択をONにして選択済み対象物に移動
                        </span>
                      } sx={{p:0}} />
                    </Grid>
                  </Grid>
                  <Box sx={{ width: 0.8 }}>
                    <TextField
                      label="対象物名、JAN/部品コード、メーカーなどを入力"
                      name="workSearchKeyword" value={workSearchKeyword}
                      variant="outlined" size="small"
                      margin="dense" fullWidth
                      onChange={(e)=>(changeAutoComp(SELMODE.WORK, e))}
                    />
                  </Box>
                  <Box sx={{ mt:0, pr:4 }}>
                    {workCandidateList.map(row => {
                      const image = pickImageByClass(row, workRepresentativeModels);
                      const showLoading = isWorkImageLoading && image === DEFAULT_IMAGE_BLACK_URL;

                      return (
                        <Card key={row.attr['class-id']}
                              sx={{display: 'flex', height: CARD_HEIGHT, mt: 2, cursor: "pointer"}}
                              onClick={() => {
                                setWorkDialogId(row.attr['class-id']);
                                setWorkDialogOpen(true);
                              }}>
                          <CardMedia
                            component="img"
                            sx={{width: IMAGE_WIDTH, height: IMAGE_HEIGHT, objectFit: 'contain'}}
                            image={showLoading ? LOADING_IMAGE_URL : image}
                            alt={row.attr.nameJp}
                          />
                          <CardContent sx={{p: 1}}>
                            <Typography variant="subtitle2" component='p'
                                        sx={{mt: 0.5, maxHeight: "44px", overflow: "hidden"}}>
                              製品名：{row.attr.nameJp}
                            </Typography>
                            <FormControlLabel
                              control={
                                <Switch
                                  name={row.attr['class-id']}
                                  checked={resultInputs.classIds.includes(row.attr['class-id'])}
                                  onChange={(e, chk) => {
                                    changeSwitch(SELMODE.WORK, row.attr['class-id'], chk)
                                  }}
                                />
                              }
                              label="選択"
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            />
                          </CardContent>
                        </Card>
                      )
                    })}
                  </Box>
                </Grid>
                <Grid size={{xs:6}} sx={{borderLeft:"1px solid rgba(0, 0, 0, 0.23)",pt:2,pl:2}}>
                  <InputLabel variant='standard' sx={{pt:0,color: 'text.primary'}}>選択済み対象物</InputLabel>
                  <Box sx={{ mt:"74px", pr:2 }}>
                    {workSelectedList.map(row => {
                      const image = pickImageByClass(row, workRepresentativeModels);
                      const showLoading = isWorkImageLoading && image === DEFAULT_IMAGE_BLACK_URL;

                      return (
                        <Card sx={{mt: 2}} key={row.attr['class-id']}>
                          <Grid container spacing={0} alignItems="start"
                                sx={{p: 0, m: 0, color: "text.primary", flexWrap: "nowrap", cursor: "pointer"}}
                                onClick={() => {
                                  setWorkDialogId(row.attr['class-id']);
                                  setWorkDialogOpen(true);
                                }}>
                            <Grid sx={{flexShrink: 0}}>
                              <CardMedia
                                component="img"
                                sx={{width: IMAGE_WIDTH, height: IMAGE_HEIGHT, objectFit: 'contain'}}
                                image={showLoading ? LOADING_IMAGE_URL : image}
                                alt={row.attr.nameJp}
                              />
                            </Grid>
                            <Grid>
                              <CardContent sx={{p: 1, pb: "0 !important"}}>
                                <Typography variant="subtitle2" component='p'
                                            sx={{mt: 0.5, maxHeight: "44px", overflow: "hidden"}}>
                                  製品名：{row.attr.nameJp}
                                </Typography>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      name={row.attr['class-id']}
                                      checked
                                      onChange={() => {
                                        changeSwitch(SELMODE.WORK, row.attr['class-id'], false)
                                      }}
                                    />
                                  }
                                  label="選択"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                />
                              </CardContent>
                            </Grid>
                          </Grid>
                        </Card>
                      )
                    })}
                  </Box>

                </Grid>
              </Grid>
            </Box>

          </form>
        </Card>
      </Container>

      <Box component="section" sx={{ textAlign:"center" }}>
        <Pjdb1Button
          label="戻る"
          variant="contained"
          color="inherit"
          isLoading={isLoading}
          sx={{m:2}}
          onClick={()=>{void navigate(TRAJECTORY_URLS.TRAJECTORY_REGISTE.URL);}}
        />
        <Pjdb1Button
          label="軌道登録"
          variant="contained"
          color="primary"
          isLoading={isLoading}
          sx={{m:2}}
          onClick={()=>{
            void editData();
          }}
        />
      </Box>

      <ConfirmDialog
        title="軌道登録確認"
        message="軌道登録を行いますか？"
        confirmButton="軌道登録"
        confirmButtonStyle="primary"
      />


      <ArmDetailDialog
        armId={armDialogId}
        open={armDialogOpen}
        onClose={() => { setArmDialogOpen(false) }}
      />
      <HandDetailDialog
        handId={handDialogId}
        open={handDialogOpen}
        onClose={() => { setHandDialogOpen(false) }}
      />
      <FingertipDetailDialog
        fingertipId={fingertipDialogId}
        open={fingertipDialogOpen}
        onClose={() => { setFingertipDialogOpen(false) }}
      />
      <WorkDetailDialog
        classId={workDialogId}
        open={workDialogOpen}
        onClose={() => { setWorkDialogOpen(false) }}
      />

    </>
  )
}
